import { graphql, useStaticQuery } from "gatsby"
import { useContent } from "./useContent"
import { useMemo } from "react"

const useCollectionPageSettings = () => {
  const { settings } = useStaticQuery<GatsbyTypes.StaticSettingCollectionPageQuery>(graphql`
    query StaticSettingCollectionPage {
      settings: sanitySettingCollectionPage {
        summary: _rawSummary(resolveReferences: { maxDepth: 2 })
        gridSettings {
          _key
          _type
          resultsPerPage
          resultsPerRowDesktop
          resultsPerRowMobile
          theme
        }
      }
    }
  `)

  const { getContent } = useContent()
  const pageSummary = useMemo(() => getContent({ content: settings?.summary }), [getContent, settings?.summary])
  const productGridSection = settings?.gridSettings

  return { pageSummary, productGridSection }
}

export default useCollectionPageSettings
